import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../../primitives/ids.js";
import { DeliveryProjectIdSchema } from "./entities.js";
export const VoiceCaptureCandidateFactsV1Schema = z
    .object({
    schemaVersion: z.literal("clientops.voice-candidate-facts.v1.0"),
    candidateId: z.string().regex(/^vccf_[a-zA-Z0-9_-]+$/),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    deliveryProjectId: DeliveryProjectIdSchema.optional(),
    sourceKind: z.literal("VOICE_TRANSCRIPT"),
    sourceRef: z.string().min(1),
    facts: z
        .array(z
        .object({
        fieldKey: z.string().min(1),
        proposedValue: z.string().min(1),
        confidence: z.enum(["LOW", "MEDIUM", "HIGH"]),
    })
        .strict())
        .min(1),
    confirmationStatus: z.enum(["PENDING_CONFIRMATION", "CONFIRMED", "REJECTED"]),
    createdAt: z.string().datetime(),
    confirmedAt: z.string().datetime().optional(),
})
    .strict();
export function buildVoiceCaptureCandidateFacts(input) {
    const trimmed = input.rawTranscript.trim();
    const pageMatch = trimmed.match(/(\d+)\s*pages?/i);
    const scopeLine = trimmed.split("\n").find((line) => line.trim().length > 0) ?? trimmed;
    const facts = [
        {
            fieldKey: "scopeSummary",
            proposedValue: scopeLine.slice(0, 500),
            confidence: "MEDIUM",
        },
    ];
    if (pageMatch) {
        facts.push({
            fieldKey: "pageCount",
            proposedValue: pageMatch[1],
            confidence: "HIGH",
        });
    }
    return VoiceCaptureCandidateFactsV1Schema.parse({
        schemaVersion: "clientops.voice-candidate-facts.v1.0",
        candidateId: input.candidateId,
        agencyId: input.agencyId,
        projectId: input.projectId,
        deliveryProjectId: input.deliveryProjectId,
        sourceKind: "VOICE_TRANSCRIPT",
        sourceRef: input.sourceRef,
        facts,
        confirmationStatus: "PENDING_CONFIRMATION",
        createdAt: input.now ?? new Date().toISOString(),
    });
}
export function confirmVoiceCaptureCandidateFacts(candidate, decision, now) {
    if (candidate.confirmationStatus !== "PENDING_CONFIRMATION") {
        throw new Error("candidate_already_resolved");
    }
    const ts = now ?? new Date().toISOString();
    return VoiceCaptureCandidateFactsV1Schema.parse({
        ...candidate,
        confirmationStatus: decision === "CONFIRM" ? "CONFIRMED" : "REJECTED",
        confirmedAt: ts,
    });
}
//# sourceMappingURL=voice-candidate.js.map